/**
 * @fileoverview Email Verification Modal
 * @description Modal shown after signup to prompt user to verify email
 */

import { Trans, useTranslation } from 'react-i18next'
import { Modal, Text, Stack, Center } from '@mantine/core'
import { IconMailCheck } from '@tabler/icons-react'

interface EmailVerificationModalProps {
  opened: boolean
  email: string
  onClose: () => void
}

/**
 * Modal prompting user to verify their email after signup
 */
export const EmailVerificationModal = ({
  opened,
  email,
  onClose,
}: EmailVerificationModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('teacher_signup.verify_email_title')}
      centered
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      size="md"
    >
      <Stack spacing="lg">
        <Center>
          <IconMailCheck size={64} color="teal" stroke={1.5} />
        </Center>

        <Text align="center" size="xl" weight={700}>
          {t('teacher_signup.verify_email_almost_done')}
        </Text>

        <Text align="center" size="md">
          {t('teacher_signup.verify_email_description')}
        </Text>

        <Text align="center" size="md">
          {t('teacher_signup.verify_email_sent_to')} <strong>{email}</strong>
        </Text>

        <Text align="center" size="sm" color="dimmed">
          <Trans
            i18nKey="teacher_signup.verify_email_check_spam"
            components={{ strong: <strong /> }}
          />
        </Text>
      </Stack>
    </Modal>
  )
}
